var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4148_373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 22H8V23.3334H0V22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 26H8.00011V27.3334H2.66675V26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 34H8.00011V35.3334H2.66675V34Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 30H8V31.3334H0V30Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 10H29.3334V12.6666H28V10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6666 8.66675H29.3333V4.66675H24.6666C24.2991 4.66675 24 4.96581 24 5.33339V8.00011C24 8.36769 24.2991 8.66675 24.6666 8.66675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3335 2.25854L30.6667 4.48065V8.853L37.3335 11.0752V2.25854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6667 0.666748H40.0001V12.6667H38.6667V0.666748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1855 18.29L14.4734 17.5783C14.1658 17.2705 13.7147 17.1768 13.3243 17.3391L13.3014 17.3487C12.916 17.5077 12.6667 17.8745 12.6667 18.2826V19.3335H11.9827L23.9343 29.7263C24.1375 29.9028 24.3976 30.0001 24.6667 30.0001C24.9357 30.0001 25.1959 29.9028 25.399 29.7263L39.9478 17.075C39.8466 16.8354 39.6092 16.6667 39.3332 16.6667H16.8087L15.1855 18.29Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99989 7.3335C9.63231 7.3335 9.33325 7.63256 9.33325 8.00014V10.6668C9.33325 11.0344 9.63231 11.3334 9.99989 11.3334C10.3675 11.3334 10.6665 11.0344 10.6665 10.6668V8.00014C10.6665 7.63256 10.3675 7.3335 9.99989 7.3335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.95067 19.3335H9.33325V37.2037L19.9172 28.0001L9.95067 19.3335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 37.2037V18.7966L29.416 28.0001L40 37.2037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2739 30.7324C25.8281 31.1199 25.2573 31.3334 24.6667 31.3334C24.0761 31.3334 23.5053 31.1199 23.0595 30.7324L20.9333 28.8835L9.3855 38.9251C9.48667 39.1647 9.72401 39.3334 10 39.3334H39.3334C39.6094 39.3334 39.8467 39.1647 39.9479 38.9251L28.4 28.8835L26.2739 30.7324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7933 16.116L12.8144 16.1072C13.6027 15.7792 14.4961 15.905 15.1701 16.42L17.0832 14.5069C16.5654 13.8454 16.4411 12.9473 16.7747 12.1457L16.7823 12.1272C17.1118 11.3289 17.8333 10.785 18.6666 10.6839V7.98308C17.8333 7.88198 17.1118 7.33815 16.7825 6.54034L16.7763 6.52519C16.4412 5.72011 16.5654 4.82175 17.0833 4.16011L15.1733 2.25026C14.5118 2.76808 13.6137 2.89237 12.8121 2.55886L12.7936 2.55112C11.9952 2.22159 11.4513 1.50011 11.3502 0.666748H8.6495C8.54841 1.50011 8.00458 2.22159 7.20677 2.55081L7.19161 2.55706C6.38661 2.89206 5.48817 2.768 4.82653 2.25011L2.91669 4.16011C3.4345 4.82159 3.5588 5.71972 3.2252 6.52128L3.21755 6.53979C2.88802 7.33815 2.16653 7.88206 1.33325 7.98315V10.6839C2.16669 10.785 2.8881 11.3289 3.21731 12.1267L3.22356 12.1417C3.55864 12.9468 3.4345 13.8452 2.91661 14.5068L4.82966 16.4198C5.50364 15.9049 6.39716 15.7791 7.1877 16.1082L7.20606 16.1158C8.00442 16.4453 8.54833 17.1668 8.64942 18.0001H11.3501C11.4513 17.1667 11.9952 16.4453 12.7933 16.116ZM12.6665 11.3335C13.0341 11.3335 13.3332 11.0344 13.3332 10.6668V8.00011C13.3332 6.16214 11.8379 4.66675 9.99981 4.66675C8.16177 4.66675 6.66653 6.16214 6.66653 8.00011V10.6667C6.66653 12.5047 8.16184 14.0001 9.99989 14.0001H10.6665V15.3335H9.99989C7.42661 15.3335 5.33325 13.24 5.33325 10.6668V8.00011C5.33325 5.42683 7.42669 3.33347 9.99989 3.33347C12.5731 3.33347 14.6665 5.4269 14.6665 8.00011V10.6667C14.6665 11.7695 13.7693 12.6667 12.6665 12.6667C12.1548 12.6667 11.6873 12.4735 11.3332 12.1563C10.9791 12.4736 10.5116 12.6667 9.99981 12.6667C8.89708 12.6667 7.99981 11.7695 7.99981 10.6667V8.00011C7.99981 6.89737 8.89708 6.00011 9.99981 6.00011C11.1025 6.00011 11.9998 6.89737 11.9998 8.00011V10.6667C11.9999 11.0343 12.299 11.3335 12.6665 11.3335Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4148_373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02);
export default __webpack_public_path__ + "static/media/02.562d3872d43461eb30028ceaf0deea6d.svg";
export { ForwardRef as ReactComponent };